import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FaXmark } from "react-icons/fa6";
import { setCommonFilters } from "../../WorkbookSlice";
import { handleFilterInDashboard } from "../../../smallFunction/SmallFunctions";

export default function Number({
  updateNumberFilterItem,
  filterItem,
  dashboardSheetID: dashIDs,
  isFilterVisibleInDashboard,
  dashboardType,
}) {
  // console.log(filterItem);

  const [tempValues, setTempValues] = useState([]); // Holds immediate user input
  const [numberValues, setNumberValues] = useState([]); // Updates after debounce
  // console.log(numberValues);

  useEffect(() => {
    setTempValues([filterItem?.minValue ?? "", filterItem?.maxValue ?? ""]);
    setNumberValues([filterItem?.minValue ?? "", filterItem?.maxValue ?? ""]);
  }, [filterItem?.minValue, filterItem?.maxValue]);

  const dispatch = useDispatch();

  const handleChange = (e, index) => {
    let value = e.target.value.replace(/,/g, ""); // Remove commas before processing

    if (!/^\d*$/.test(value)) return; // Allow only numbers

    let newValues = [...tempValues];
    newValues[index] = value; // Update tempValues
    setTempValues(newValues);
    let minValue, maxValue;
    switch (filterItem?.selectedOperator) {
      case "BETWEEN":
        minValue = newValues[0];
        maxValue = newValues[1];
        break;
      case ">":
      case "<":
      case ">=":
      case "=<":
        minValue = newValues[0];
        break;
      default:
        console.error("Operator is not defined");
        return;
    }

    const updatedFilterItem = {
      ...filterItem,
      minValue: minValue ?? null, // Use `??` to keep `0`
      maxValue: maxValue ?? null, // Use `??` to keep `0`
    };

    // console.log("update filter", updatedFilterItem);

    updateNumberFilterItem(filterItem.dataType, updatedFilterItem);
  };

  // Debounce effect - updates numberValues after 2s
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setNumberValues(tempValues);
    }, 2000); // 2s debounce delay

    return () => clearTimeout(debounceTimeout); // Cleanup timeout if tempValues changes
  }, [tempValues]);

  function opeartorMarking(opeartor) {
    switch (opeartor) {
      case ">":
        return "Greater Than";
      case ">=":
        return "Greater Than Equal To";
      case "<":
        return "Less Than";
      case "<=":
        return "Less Than Equal To";
      case "BETWEEN":
        return "Between";
      default:
        return "";
    }
  }

  return (
    <div className="px-2 py-1 flex flex-col w-full items-start justify-center gap-1">
      <header className="flex items-center justify-between w-full">
        <h1 className="w-full text-left font-light">
          {`${filterItem.selectedMeasure}_${filterItem.rename}`}
          <span className="text-[10px] font-light">{`(${opeartorMarking(
            filterItem?.selectedOperator
          )})`}</span>
        </h1>
        {dashboardType === "makeDashboard" && isFilterVisibleInDashboard ? (
          <FaXmark
            className="font-light cursor-pointer text-transparent hover:text-gray-600"
            onClick={() =>
              handleFilterInDashboard({
                item: filterItem,
                dashIDs,
                dispatch,
                setCommonFilters,
              })
            }
          />
        ) : null}
      </header>
      <div className="flex w-full items-center justify-between gap-1">
        <input
          type="text"
          className={`px-[2px] py-[1px] text-sm border border-gray-300 rounded ${
            filterItem?.selectedOperator === "BETWEEN" ? "w-[47.5%]" : "w-full"
          } focus:outline-none font-light`}
          id="0"
          value={
            tempValues[0] !== ""
              ? new Intl.NumberFormat("en-IN").format(tempValues[0])
              : ""
          }
          onChange={(e) => handleChange(e, 0)}
        />
        {filterItem?.selectedOperator === "BETWEEN" ? (
          <input
            type="text"
            className="px-[2px] py-[1px] text-sm border border-gray-300 rounded w-[47.5%] focus:outline-none font-light"
            id="1"
            value={
              tempValues[1] !== ""
                ? new Intl.NumberFormat("en-IN").format(tempValues[1])
                : ""
            }
            onChange={(e) => handleChange(e, 1)}
          />
        ) : null}
      </div>
    </div>
  );
}
